// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"Details_detailsWrapper__fOzr7","detailPoints":"Details_detailPoints__VZDAh"};